import { URLParamsSegmentModal } from './URLParamsSegment';

export function UTMParamsSegmentModal({ ...props }) {
  return <URLParamsSegmentModal {...props} utmParams={true} />;
}
